export interface Rule {
  message: string;
  pattern: RegExp | string;
}

export const RULES: Rule[] = [
  { message: 'Letra maiúscula (A-Z)', pattern: /^(?=.*[A-Z])/ },
  { message: 'Um caractere especial (#$%)', pattern: /^(?=.*[@$!%*#?&_;~,.'":}{|()[/+<>/-])/ },
  { message: 'Letra minúscula (a-z)', pattern: /^(?=.*[a-z])/ },
  { message: 'No mínimo 8 caracteres', pattern: /^.{8,}$/ },
  { message: 'Um número (0-9)', pattern: /(?=.*[0-9])/ },
];

export const getMatchingRules = (password: string, rules: Rule[] = RULES): Rule[] => rules.filter((rule) => password.match(rule.pattern));

export const isValidPassword = (password: string, rules: Rule[] = RULES): boolean => {
  const mathRules = getMatchingRules(password);
  return mathRules.length === rules.length;
};
